__turbopack_context__.v({
  "badge": "ProductsV2-module__8FXNua__badge",
  "card": "ProductsV2-module__8FXNua__card",
  "container": "ProductsV2-module__8FXNua__container",
  "content": "ProductsV2-module__8FXNua__content",
  "grid": "ProductsV2-module__8FXNua__grid",
  "header": "ProductsV2-module__8FXNua__header",
  "image": "ProductsV2-module__8FXNua__image",
  "imageWrapper": "ProductsV2-module__8FXNua__imageWrapper",
  "name": "ProductsV2-module__8FXNua__name",
  "price": "ProductsV2-module__8FXNua__price",
  "rating": "ProductsV2-module__8FXNua__rating",
  "section": "ProductsV2-module__8FXNua__section",
  "star": "ProductsV2-module__8FXNua__star",
  "title": "ProductsV2-module__8FXNua__title",
  "viewAll": "ProductsV2-module__8FXNua__viewAll",
});
